/**
 * Checks if the string is purely a number and if so
 * converts it to a number type. Otherwise returns the original string.
 * If the string is a mixture of digits and non-digits it won't be
 * converted.
 *
 * @param str - a string which may contain purely a number or not.
 * @returns number if possible or else the original string.
 * @internal
 */
export function convertToNumberIfPureNumber(str: string): string | number {
  const valueAsNumber = Number(str);

  return Number.isNaN(valueAsNumber) ? str : valueAsNumber;
}
